import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { Cart } from "@insite/client-framework/Services/CartService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getCartState,
    getCurrentCartState,
    hasProductsWithInvalidPrice,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    styles?: ButtonPresentationProps;
    cart: Cart;
}

const mapStateToProps = (state: ApplicationState) => {
    const { cartId, isPlacingOrder, isCheckingOutWithPayPay } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const { sessionId, redirectResult } = parseQueryString<{ sessionId?: string; redirectResult?: string }>(
        getLocation(state).search,
    );

    return {
        isDisabled:
            cartState.isLoading ||
            isPlacingOrder ||
            isCheckingOutWithPayPay ||
            (!!sessionId && !!redirectResult) ||
            hasProductsWithInvalidPrice(cartState.value) ||
            cartState.value?.hasInsufficientInventory === true ||
            !cartState.value?.canCheckOut,
        cartState,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const CheckoutReviewAndSubmitPlaceOrderButton: FC<Props> = ({ isDisabled, styles, cartState }) => {
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        (window as any).placeOrderButton = event.currentTarget;

        // reset before validating; the carrier service form sets this synchronously on submit
        (window as any).isCarrierServiceFormValid = true;
        document.getElementById("reviewAndSubmitCarrierServiceForm-submit")?.click();

        if ((window as any).isCarrierServiceFormValid === false) {
            return;
        }

        document.getElementById("reviewAndSubmitPaymentForm-submit")?.click();
    };
    const hasSingleInstance = (cartLine: any) => {
        const occurrences = cartLine.filter((item: any) => item?.properties.discontinuedProduct === "true");
        return occurrences.length > 0;
    };

    const isDiscontinuedProductPresent =
        cartState?.value?.cartLines && cartState?.value?.cartLines?.length > 0
            ? hasSingleInstance(cartState?.value?.cartLines)
            : false;
    return (
        <>
            <Button
                type="submit"
                disabled={isDisabled || isDiscontinuedProductPresent}
                data-test-selector="checkoutReviewAndSubmit_placeOrder"
                {...styles}
                onClick={handleClick}
            >
                {translate("Place Order")}
            </Button>
        </>
    );
};

export default connect(mapStateToProps)(CheckoutReviewAndSubmitPlaceOrderButton);
